import React from "react";
import { DropdownBox } from "@softura/fluentuipackage";
import "./Dropdown.scss";

interface IProps {
  placeholder?: string;
  options?: any;
  labelText?: string;
  className?: string;
  defaultSelectedKey?: any;
  onChange?: any;
  onRenderOption?: any;
  onRenderTitle?: any;
  disabled?: boolean;
  key?: string;
  name?: any;
  errorMessage?: string;
  value?: any;
  required?: any;
  selectedKey?: any;
  id?: any;
  responsiveMode?: any;
  styles?: any;
}
const DropdownContainer = ({
  placeholder,
  options,
  labelText,
  className,
  defaultSelectedKey,
  onChange,
  onRenderOption,
  onRenderTitle,
  disabled,
  key,
  name,
  errorMessage,
  value,
  required,
  id,
  styles,
  selectedKey,
}: IProps) => {
  if (options) {
    Object.values(options).forEach((x: any, _i: any) => {
      x["key"] = x.value;
    });
  }

  return (
    <DropdownBox
      className={`${className}`}
      placeholder={placeholder}
      options={options}
      label={labelText}
      onChange={onChange}
      onRenderOption={onRenderOption}
      onRenderTitle={onRenderTitle}
      disabled={disabled}
      defaultSelectedKey={defaultSelectedKey}
      key={key}
      name={name}
      errorMessage={errorMessage}
      selectedItem={value}
      required={required}
      id={id}
      responsiveMode="large"
      styles={styles}
      selectedKey={selectedKey}
     data-attribute="index_labelText_Dropdown" />
  );
};

export default DropdownContainer;
